/* eslint-disable react/no-array-index-key */
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import { Input } from 'antd';
import './style.css';
import _ from 'lodash';
import QuestionHeader from '../QuestionHeader';
import AudioButton from '../AudioButton';

const FillInTheBlankWithHint = ({ data, onSubmit, userData, questionIndex = 0 }) => {
  const questionCharacters = data.question
    .trim()
    .split(/(\w)/)
    .filter((x) => x !== '');

  // Tách mảng theo ký tự đầu tiên (từ gợi ý), giữ lại từ gợi ý.
  const [filledCharacters, setFilledCharacters] = useState([]);
  // const [filledCharacters, setFilledCharacters] = useState([{ id: 0, answer: questionCharacters, type: 'fixed' }]);

  useEffect(() => {
    if (userData) {
      setFilledCharacters(userData.answers);
    }
  }, [userData]);

  const onHandleChange = useCallback(
    (index) => (e) => {
      const text = _.cloneDeep(filledCharacters);
      const foundIndex = _.findIndex(filledCharacters, (x) => x.id === index);

      if (foundIndex !== -1) {
        text[foundIndex].answer = e.target.value;
      } else {
        text.push({ id: index, answer: e.target.value, type: 'fill' });
      }
      setFilledCharacters(text);
    },
    [filledCharacters],
  );

  const renderQuestion = useCallback(() => {
    return questionCharacters.map((item, index) => {
      const value = _.find(filledCharacters, (x) => x.id === index);
      return (
        <Fragment key={index}>
          {
            item === '_' ?
              <Input autoComplete='off' value={value?.answer} className='input-fill-in-the-blank-with-hint' style={{ width: 28, marginInline: 6 }} maxLength={1} onChange={onHandleChange(index)} /> :
              <span className='questionText'>{item}</span>
          }

          {/* {index === 0 ? (
            <span className='questionText tw-mr-2'>{item}</span>
          ) : (
            <Input value={value?.answer} className='input-fill-in-the-blank-with-hint' style={{ width: 28, marginLeft: 12 }} maxLength={1} onChange={onHandleChange(index)} />
          )} */}
        </Fragment>
      );
    });
  }, [filledCharacters, onHandleChange, questionCharacters]);

  return (
    <Card>
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='FillInTheBlankWithHint' />
      </CardHeader>

      <CardBody style={{ minHeight: 300 }}>
        <AudioButton audioUrl={data.audioUrl} />
        {data.imageUrl && (
          <div className='mb-4'>
            <img src={data.imageUrl} alt='' style={{ height: 220 }} />
          </div>
        )}
        <div>{renderQuestion()}</div>
      </CardBody>

      <CardFooter>
        <Button
          color='primary'
          onClick={() => {
            const answer = filledCharacters.map((item) => {
              return item.answer;
            }).toString().replaceAll(',', '');
            // const result = _.isEqual(_.map(filledCharacters, 'answer'), questionCharacters);

            const result = answer === data.answers;
            if (onSubmit && typeof onSubmit === 'function') onSubmit({ answers: filledCharacters, result });
          }}
        >
          Submit
          <i className='fas fa-arrow-right ml-3' />
        </Button>
      </CardFooter>
    </Card>
  );
};

FillInTheBlankWithHint.propTypes = {
  data: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  userData: PropTypes.any,
  questionIndex: PropTypes.number,
};

FillInTheBlankWithHint.defaultProps = {
  onSubmit: null,
  userData: null,
  questionIndex: 0,
};

export default FillInTheBlankWithHint;
